<template>
  <van-tabbar v-model="active" class="active_tab">
    <van-tabbar-item
        v-for="(item,index) in tabbars"
        :key="index"
        @click="tab(index,item)">

      <span :class="currIndex == index ? active:''">{{item.title}}</span>
      <template slot="icon" slot-scope="props">
        <van-icon :name="item.normal" :color="props.active? '#1989fa' : ''" size="30"/>
<!--        <img :src="props.active ? item.active : item.normal">-->
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import {Tabbar, TabbarItem, Icon} from "vant";
import { langPackage } from "@/config/lang/homeLang";
import { selectLang } from "@/config/setLanguage"
export default {
  name: "TabBar",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Icon.name]: Icon
  },
  props: {
    tabbars: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      currIndex: 0,
      active: 0,
      commonText: {}
    };
  },
  methods: {
    tab(index, val) {
      this.currIndex = index;
      this.$route.meta.keepAlive = false
      this.$router.push('/' + val.name);
    },
  },
  mounted() {
    this.tabbars.filter((item, i) => {
      if(window.location.pathname.indexOf(item.name) == 1){
        this.active = i
      }
    })
  },
  watch: {
    $route(to, from){
      this.tabbars.filter((item, i) => {
        if(to.path.indexOf(item.name) == 1){
          this.active = i
        }
      })
    }
  },
  created(){
    //获取语言包
    selectLang(langPackage).then(langtxt =>{
      this.langText = langtxt.langtxt;
      this.commonText = langtxt.common;
      console.log(langtxt.common)
      this.tabbars[0].title=this.commonText.homePage
      this.tabbars[1].title=this.commonText.classification
      this.tabbars[2].title=this.commonText.shopping
      this.tabbars[3].title=this.commonText.mine
    });
  },
};
</script>

<style lang="scss" scoped>
.active_tab img {
  width: 26px;
  height: 26px;
}

.van-tabbar-item--active {
  color: #1989fa;
}

.active_tab{
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
</style>
